import type { EditorState } from 'lexical';
import type {
  ContentLexicalStateV1,
  SupportedLexicalDisplayNode,
} from '@soundxyz/utils/lexical/ContentLexicalStateV1';

function generateTextForNode(
  node?: SupportedLexicalDisplayNode | ContentLexicalStateV1['root'],
): string {
  if (!node) {
    return '';
  }
  if (node.type === 'root') {
    return node.children.map(generateTextForNode).join('');
  } else if (node.type === 'text') {
    return node.text;
  } else if (node.type === 'paragraph') {
    return node.children.map(generateTextForNode).join('');
  } else if (node.type === 'custom-beautifulMention') {
    return node.value;
  } else if (node.type === 'linebreak') {
    return '\n';
  } else {
    return '';
  }
}

function getRootNode(editorState?: EditorState): SupportedLexicalDisplayNode | undefined {
  return editorState?.toJSON().root as SupportedLexicalDisplayNode | undefined;
}

function generateTextForState(editorState?: EditorState) {
  return generateTextForNode(getRootNode(editorState));
}

function getNodeTextLength(node?: SupportedLexicalDisplayNode) {
  return generateTextForNode(node).length;
}

export const LexicalUtils = {
  getRootNode,
  getNodeTextLength,
  generateTextForNode,
  generateTextForState,
};
